import './ColorColumn.css';

export function ColorColumn(product) {
	const colorData =
		product.colors?.find(({ label }) => label === product.color) ?? '';
	const colorDataColor = colorData?.value_data?.colors?.[0] ?? '';
	const colorDataImage = colorData?.value_data?.image_url ?? '';

	return (
		<div className="order-color-swatch">
			{colorDataColor && (
				<svg width="16" height="16">
					<circle
						cx="8"
						cy="8"
						r="8"
						fill={colorData.value_data.colors[0]}
					/>
				</svg>
			)}
			{colorDataImage && (
				<img
					src={colorData.value_data.image_url}
					style={{
						width: '16px',
						height: '16px',
						borderRadius: '100px',
						marginRight: '8px',
					}}
					alt="color-data"
				/>
			)}
			{product.color}
		</div>
	);
}
